(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/map-of-winners/views/list.js') >= 0) return;  svs.modules.push('/modules/map-of-winners/views/list.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.map_of_winners=_svs.map_of_winners||{};
_svs.map_of_winners.templates=_svs.map_of_winners.templates||{};
svs.map_of_winners.templates.list = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<header class=\"list-header\">\n  <h2>\n    "
    + alias3((lookupProperty(helpers,"formatCurrency")||(depth0 && lookupProperty(depth0,"formatCurrency"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"winAmount") : depth0),{"name":"formatCurrency","hash":{},"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":3,"column":32}}}))
    + " kr\n  </h2>\n  <p>vinsterna gick till:</p>\n</header>\n\n<div id=\"winType"
    + alias3(((helper = (helper = lookupProperty(helpers,"winType") || (depth0 != null ? lookupProperty(depth0,"winType") : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"winType","hash":{},"data":data,"loc":{"start":{"line":8,"column":16},"end":{"line":8,"column":27}}}) : helper)))
    + "DivRegion\"></div>";
},"useData":true});
Handlebars.partials['svs-map_of_winners-list'] = svs.map_of_winners.templates.list;
})(svs, Handlebars);


 })(window);